import instance from '../utils/axios';

class CaptchaService {

    async apply(biz) {
        return await instance.get('/crm/captcha/apply?biz='+biz);
    }
}
export default new CaptchaService();